import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        action: css`
            ${common.flexJustityAlignCenter};
        `,
        button: css`
            ${custom.button};
            padding-left: 25px;
            padding-right: 25px;
            width: auto;
            margin: 35px 25px 35px 25px;
        `,
        text: custom.stepText,
        notConfirmed: css`
            padding: 20px;
        `,
    }
}

export default styles
